import { create } from 'zustand'
import type { ChatConversation } from '@one-deployment/protocol'

/**
 * A session's conversations, kept by its chat (which holds the socket) and
 * shown in the session window's tab header, a different part of the tree.
 */
export type ConvState = {
  items: ChatConversation[]
  /** The box answered at least once; an older box never does. */
  answered: boolean
  canSwitch: boolean
  refresh: () => void
  switchTo: (id?: string) => void
}

export const useConversations = create<{ bySession: Record<string, ConvState>; set: (session: string, s: Partial<ConvState>) => void; drop: (session: string) => void }>((set) => ({
  bySession: {},
  set: (session, s) => set((st) => ({
    bySession: { ...st.bySession, [session]: { items: [], answered: false, canSwitch: false, refresh: () => {}, switchTo: () => {}, ...st.bySession[session], ...s } },
  })),
  drop: (session) => set((st) => { const { [session]: _, ...rest } = st.bySession; return { bySession: rest } }),
}))
